import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";

import { IHeaderPageTitleProps } from "@faire/help-center-utils/components/Header/HeaderPageTitle";
import { LazyDesktopHeader } from "./DesktopHeader/LazyDesktopHeader";
import { LazyMobileHeader } from "./MobileHeader/LazyMobileHeader";

export interface IHeaderProps extends IHeaderPageTitleProps {
  search?: boolean;
}

export const Header: React.FC<IHeaderProps> = ({ search, menu }) => {
  const { isMobile } = useViewport();
  if (isMobile) {
    return <LazyMobileHeader menu={menu} search={search} />;
  }
  return <LazyDesktopHeader menu={menu} search={search} />;
};
